import React, {useState} from "react"
import AsyncSelect from "react-select/async"
import {groupStyles, selectStyler} from "../SelectStyler";
import Rule from "../../store/entities/rules/Rule";
import {observer} from "mobx-react-lite";

export interface IRuleInputOption {
    input_title: string,
    input_name: string,
    input_type: string
}


export const AsyncRuleInputSelection = observer(({rule}: { rule: Rule }) => {

    return <AsyncSelect<IRuleInputOption>
        placeholder={"Выбрать..."}
        {...selectStyler}
        getOptionValue={(option) => option.input_name}
        formatOptionLabel={function(option) {
            let label = option.input_title;
            if (option.input_type === "ozonInputProductFeature") {
                label = `${label} <span style="color: #aaa; font-size: 0.9em">(${option.input_name})</span>`;
            }
            return (
                <span dangerouslySetInnerHTML={{ __html: label }} />
            );
        }}
        isClearable
        onFocus={() => rule.loadDefaultOption()}
        value={rule.input.rule}
        onChange={(value) => {
            if (value) {
                rule.setRuleInput(value)
            } else {
                rule.deleteRuleInput()
            }
        }}
        defaultOptions={rule.defaultOption}
        loadOptions={(inputValue: string) => rule.getOptions(inputValue)}
    />
})

